<mat-card style="border-color: #5775a8;">

  <div class="flex flex-row w-full">
    <div class="flex flex-row w-full">
      <span style="font-size:small;color: grey;padding-left: 20px;">
        The 'Files' section contain any uploaded attachments, including photos submitted by the complainant. Use the 'Files' tab to upload and store any documents related to inspections, complaints, or businesses - such as inspection forms, notes, pictures, etc.
      </span>
    </div>
    <div style="padding-right: 20px;">
      <button mat-raised-button (click)="addFile()" style="background: #7ABDF3; padding-right: 20px;">
        <mat-icon>save_as</mat-icon> Add 
      </button>
    </div>
  </div>
  <br />

  <mat-card-content>
    <div class="flex flex-col w-full" style="overflow-x:auto;">
      <div class="flex flex-row w-full">

        <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #MatSort="matSort" class="w-full">

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let complaint"><a (click)="rowClick(complaint)">{{complaint.name}}</a>
            </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
            <td mat-cell *matCellDef="let complaint">{{complaint.description}}
            </td>
          </ng-container>
          <ng-container matColumnDef="staff">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded By</th>
            <td mat-cell *matCellDef="let complaint">
              {{complaint.staff}}
            </td>
          </ng-container>
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
            <td mat-cell *matCellDef="let complaint">
              {{complaint.date}}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

        </table>
      </div>

    </div>
  </mat-card-content>

</mat-card>